<template>
  <div class="loan-application-page confirmation-page">
    <!-- 导航栏 -->
    <HanderNav title="填写资料" />

    <!-- 顶部额度展示区域 -->
    <div class="header-conatiner header-section">
      <div class="amount-display">
        <div class="amount-title-tip">最高可借额度(元)</div>
        <div class="amount-value">
          <span class="currency">¥</span>
          <span class="amount">{{ $format.formatAmount(formData.loan_amount) }}</span>
        </div>
        <div class="img-box">
          <img src="/images/image-2.png" />
        </div>
      </div>
    </div>

    <!-- 产品特性说明 -->
    <div class="features-section">
      <div class="feature-item">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
          <circle cx="6.78467" cy="6.43823" r="5.5" stroke="#2E517B" />
          <path d="M4.27979 6.45469L5.73096 7.90586C6.12145 8.29636 6.75456 8.29639 7.1451 7.90594L10.0587 4.99292"
            stroke="#2E517B" stroke-linecap="round" />
        </svg>
        <span>正规持牌机构放款</span>
      </div>
      <div class="feature-item">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
          <circle cx="6.78467" cy="6.43823" r="5.5" stroke="#2E517B" />
          <path d="M4.27979 6.45469L5.73096 7.90586C6.12145 8.29636 6.75456 8.29639 7.1451 7.90594L10.0587 4.99292"
            stroke="#2E517B" stroke-linecap="round" />
        </svg>
        <span>年化利率 7.2%-24%(以实际为准)</span>
      </div>
      <div class="feature-item">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
          <circle cx="6.78467" cy="6.43823" r="5.5" stroke="#2E517B" />
          <path d="M4.27979 6.45469L5.73096 7.90586C6.12145 8.29636 6.75456 8.29639 7.1451 7.90594L10.0587 4.99292"
            stroke="#2E517B" stroke-linecap="round" />
        </svg>
        <span>随借随还</span>
      </div>
    </div>

    <!-- 提示信息 -->
    <div v-if="false" class="tip-section">
      <img src="http://localhost:3845/assets/6e24e82c287252243ac21f6fbdb72cc3039588c9.svg" alt="提示图标" />
      <span>我们将严格保密您的个人信息安全，请放心填写</span>
    </div>

    <!-- 进度条 -->
    <div class="progress-section">
      <div class="progress-container">
        <div class="progress-item completed">
          <div class="progress-icon phone">
            <img src="/images/icon_phone.png" alt="资料填写" />
          </div>
        </div>
        <div class="progress-line completed"></div>
        <div class="progress-item active">
          <div class="progress-icon">
            <img src="/images/icon_full.png" alt="手机注册" />
          </div>
        </div>
        <div class="progress-line"></div>
        <div class="progress-item">
          <div class="progress-icon walltet">
            <img src="/images/icon-wallet.png" alt="领取额度" />
          </div>
        </div>
      </div>
      <div class="title-box">
        <span class="progress-text" style="color: black">手机注册</span>
        <span class="progress-text active">资料填写</span>
        <span class="progress-text">领取额度</span>
      </div>
    </div>

    <!-- 提示信息2 -->
    <div class="tip-section-2">
      <span>请完善以下资料填写，以便快速评估！</span>
    </div>

    <!-- 提示信息3 -->
    <div class="tip-section-3">
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
        <path
          d="M2.80908 4.53432L11.063 2.12549L19.3091 4.53432V9.47427C19.3091 14.6665 15.9863 19.276 11.0603 20.9174C6.13296 19.2761 2.80908 14.6655 2.80908 9.47198V4.53432Z"
          fill="#FF7B1B" stroke="#FF7B1B" stroke-width="1.5" stroke-linejoin="round" />
        <path
          d="M11.0591 1.37744C11.1311 1.37704 11.2031 1.38539 11.2729 1.40576L19.519 3.81396C19.8389 3.9074 20.0591 4.20146 20.0591 4.53467V9.47412C20.0591 14.9892 16.5296 19.886 11.2974 21.6294C11.2201 21.6551 11.1396 21.6667 11.0591 21.6665V1.37744Z"
          fill="url(#paint0_linear_15_2154)" />
        <path d="M6.93408 10.8339L10.1424 14.0422L15.6424 8.54224" stroke="white" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round" />
        <defs>
          <linearGradient id="paint0_linear_15_2154" x1="16.2095" y1="18.4616" x2="11.0671" y2="3.98642"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF7B1B" />
            <stop offset="1" stop-color="#EB6504" />
          </linearGradient>
        </defs>
      </svg>
      <span>我们将严格保密您的个人信息安全，请放心填写</span>
    </div>

    <!-- 基本信息表单 -->
    <div class="form-section">
      <div class="form-card">
        <div class="form-header">
          <i></i>
          <span>请完善以下资料填写，以便快速评估！</span>
        </div>

        <div class="form-content">
          <div class="form-item">
            <label>真实姓名</label>
            <div class="input-box">
              <input v-model="formData.name" placeholder="请输入" />
            </div>
          </div>
          <div class="form-item">
            <label>身份证号</label>
            <div class="input-box">
              <input v-model="formData.identity" placeholder="请输入" @blur="blurIdentity" />
              <p v-if="identityError" class="err-tip">身份证号码错误</p>
            </div>
          </div>
          <div class="form-item" v-if="false">
            <label>年龄</label>
            <div class="input-box">
              <input type="number" readonly v-model="formData.age" placeholder="请输入" />
            </div>
          </div>
          <div class="form-item" v-if="false">
            <label>性别</label>
            <div class="gender-selector">
              <!-- @click="formData.gender = '1'" -->
              <button class="gender-btn" :class="{ active: formData.gender === '1' }">
                男
              </button>
              <button class="gender-btn" :class="{ active: formData.gender === '2' }">
                女
              </button>
            </div>
          </div>

          <div class="form-item">
            <label>现居住地</label>
            <div class="location-selector" @click="openSeleteAddress">
              <span>{{ location }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                <g clip-path="url(#clip0_15_2345)">
                  <path
                    d="M4.51603 12.3223C3.1588 12.7294 2.31934 13.2919 2.31934 13.9132C2.31934 15.1559 5.6772 16.1632 9.81934 16.1632C13.9615 16.1632 17.3193 15.1559 17.3193 13.9132C17.3193 13.2919 16.4799 12.7294 15.1226 12.3223"
                    stroke="#254774" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M9.81934 13.1633C9.81934 13.1633 14.6943 9.97733 14.6943 6.29401C14.6943 3.66752 12.5117 1.53833 9.81934 1.53833C7.12695 1.53833 4.94434 3.66752 4.94434 6.29401C4.94434 9.97733 9.81934 13.1633 9.81934 13.1633Z"
                    stroke="#254774" stroke-width="1.5" stroke-linejoin="round" />
                  <path
                    d="M9.81934 8.28833C10.8549 8.28833 11.6943 7.44886 11.6943 6.41333C11.6943 5.37781 10.8549 4.53833 9.81934 4.53833C8.78381 4.53833 7.94434 5.37781 7.94434 6.41333C7.94434 7.44886 8.78381 8.28833 9.81934 8.28833Z"
                    stroke="#254774" stroke-width="1.5" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_15_2345">
                    <rect width="18" height="18" fill="white" transform="translate(0.819336 0.0383301)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 资产信息表单 -->
    <div class="form-section mt-10">
      <div class="form-card">
        <div class="form-header">
          <i></i>
          <span>请完善以下申请信息，提高申请额度!</span>
        </div>
        <div class="form-content">
          <CapSelectorGroup v-model="zcForm" :selectors="[
            { title: '芝麻分', field: 'sesame_score', items: clue.sesame_score },
            { title: '花呗额度', field: 'huabei_quota', items: clue.huabei_quota },
            { title: '白条额度', field: 'baitiao_quota', items: clue.baitiao_quota },
            { title: '信用状况', field: 'credit_status', items: clue.credit_status_v2 },
            { title: '职业', field: 'work', items: clue.work }
          ]" :autoScroll="true"></CapSelectorGroup>
          <!-- <CapSelector title="芝麻分" :items="clue.sesame_score" v-model="formData.sesame_score" placeholder="请选择" />
          <CapSelector title="花呗额度" :items="clue.huabei_quota" v-model="formData.huabei_quota" placeholder="请选择" />
          <CapSelector title="白条额度" :items="clue.baitiao_quota" v-model="formData.baitiao_quota" placeholder="请选择" />
          <CapSelector title="信用状况" :items="clue.credit_status_v2" v-model="formData.credit_status" placeholder="请选择" />
          <CapSelector title="职业" :items="clue.work" v-model="formData.work" placeholder="请选择" /> -->
        </div>
      </div>
    </div>
    <div class="asset-tip mt-10">资产信息(可多选)</div>
    <!-- 资产信息(可多选)表单 -->
    <div class="form-section mt-10">
      <div class="form-card">
        <div class="form-header">
          <i></i>
          <span>资产信息(可多选)</span>
        </div>

        <div class="form-content">
          <div class="form-item">
            <div class="asset-selector">
              <button class="asset-btn" :class="{ active: assets.includes('car') }" @click="toggleAsset('car')">
                有车
              </button>
              <button class="asset-btn" :class="{ active: assets.includes('house') }" @click="toggleAsset('house')">
                有房
              </button>
              <button class="asset-btn" :class="{ active: assets.includes('insurance') }"
                @click="toggleAsset('insurance')">
                有保单
              </button>
              <button class="asset-btn" :class="{ active: assets.includes('social_security') }"
                @click="toggleAsset('social_security')">
                有社保
              </button>
              <button class="asset-btn" :class="{ active: assets.includes('accumulation_fund') }"
                @click="toggleAsset('accumulation_fund')">
                有公积金
              </button>
              <button class="asset-btn" :class="{ active: assets.includes('business_owner') }"
                @click="toggleAsset('business_owner')">
                有营业执照
              </button>
              <button class="asset-btn" :class="{ active: assets.includes('no') }" @click="toggleAsset('no')">
                以上都没有
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 协议同意区域 -->
    <AgreedProtocol v-model="isAgreen" customClass="mt-10" :user="user"
      :items="['PERSONAL_INFO_SHARING', 'PRIVACY_POLICY', 'PERSONAL_INFO_COLLECTION']" />
    <!-- 提交按钮 -->
    <div class="submit-button-container">
      <van-button :loading="submintLoading" loading-type="spinner" loading-text="立即借款" class="submit-button"
        :disabled="!isAgreen" @click="handleSubmit">
        立即借款
      </van-button>
    </div>
    <van-popup v-model="isShowAddress" position="bottom" round>
      <van-area :area-list="areaList2" @cancel="isShowAddress = false" @confirm="confirmAddress" />
    </van-popup>
    <van-popup v-model="isShowTip">
      <div class="tip-box">
        <div class="info-tip-popup">
          <div class="title">现在可提交</div>
          <div class="bg">
            <img src="/images/icon_submitPopup.png" />
          </div>
          <div class="info-tip-box">
            <div class="two-title">建议继续完善信息填写</div>
            <div class="msg">信息越完善，审批额度越大，审核速度越快!</div>
          </div>
          <div class="btn-group">
            <van-button class="btn btn-1" @click="isShowTip = false">继续填写</van-button>
            <van-button :disabled="true" class="btn btn-2">直接申请</van-button>
          </div>
        </div>
      </div>

    </van-popup>

  </div>
</template>

<script>
import HanderNav from "../components/HanderNav.vue";
import CapSelector from "../components/CapSelector.vue";
import CapSelectorGroup from "../components/CapSelectorGroup.vue"
import AgreedProtocol from '../components/AgreedProtocol.vue';
import { getDic, qualification } from "../api";
import cityJson from "../api/city.json"
export default {
  name: "ConfirmationPage",
  components: {
    HanderNav,
    CapSelector,
    AgreedProtocol,
    CapSelectorGroup
  },
  created() {
    var channel_id = this.$route.query?.channel_id
    var amount = this.$route.query?.amount
    var check_no = this.$route.query?.no
    if (!channel_id || !check_no) {
      this.$router.push('/404');
      return;
    }
    this.mobile = this.$cache.sessionGet("m");
    this.user.mobile = this.mobile;
    this.formData.check_no = check_no;
    this.formData.channel_key = channel_id
    this.formData.loan_amount = Number(amount);
    var loading = this.$toast.loading({ duration: 999999 });
    getDic().then(res => {
      loading.close()
      if (res.code === 1 && res.data.clue) {
        console.log('clue',res.data.clue)
        this.clue = res.data.clue
      } else {
        this.$toast.fail('失败')
      }
    }).catch(err => {
      loading.close()
    })
    const areaList = {
      province_list: {},
      city_list: {},
      county_list: {},
    };
    cityJson.forEach(province => {
      areaList.province_list[province.value] = province.label;
      if (province.children) {
        province.children.forEach(city => {
          areaList.city_list[city.value] = city.label;
          if (city.children) {
            city.children.forEach(county => {
              areaList.county_list[county.value] = county.label;
            });
          }
        });
      }
    });
    this.areaList2 = areaList;
  },
  watch: {
    formData: {
      deep: true,
      handler(newVal) {
        this.user.identity = newVal.identity;
        this.user.name = newVal.name;
      }
    }
  },
  data() {
    return {
      // 表单数据
      isShowAddress: false,
      isShowTip: false,
      city: "",
      location: "请选择地址", // 现居住地
      isAgreen: true,
      assets: [], // 资产情况（可多选）
      submintLoading: false,
      identityError: false,
      mobile: '',
      formData: {
        channel_key: "",
        check_no: "",
        name: "", // 真实姓名
        identity: '',
        age: 18, // 年龄
        gender: "1",
        province: '',
        district: '',
        city: '',
        car: '0',
        house: '0',
        accumulation_fund: '0',
        social_security: '0',
        insurance: '0',
        business_owner: '0',
        loan_amount: ''
      },
       zcForm:{
         sesame_score: "", // 芝麻分
        huabei_quota: "", // 花呗额度
        baitiao_quota: "", // 白条额度
        credit_status: "", // 信用状况
        work: "", // 职业
      },
      clue: {},
      areaList2: {},
      user: {
        name: '',
        identity: '',
        mobile: '',
      }
    };
  },
  methods: {
    blurIdentity() {
      var res = this.parseIdCard(this.formData.identity);
      if (res.error) return;
      this.formData.age = res.age
      this.formData.gender = res.gender
    },
    // 提交表单
    handleSubmit() {
      // 验证表单数据
      if (!this.validateForm()) {
        return;
      }
      this.formData.really_age = this.formData.age;
      if (this.assets.length > 0) {
        this.formData.car = this.assets.includes('car') ? "1" : "0";
        this.formData.house = this.assets.includes('house') ? "1" : "0";
        this.formData.accumulation_fund = this.assets.includes('accumulation_fund') ? "1" : "0";
        this.formData.social_security = this.assets.includes('social_security') ? "1" : "0";
        this.formData.insurance = this.assets.includes('insurance') ? "1" : "0";
        this.formData.business_owner = this.assets.includes('business_owner') ? "1" : "0";
      }
      var form={...this.formData,...this.zcForm}
      // 这里可以添加提交逻辑
      console.log("提交表单数据:",form);
      this.submintLoading = true;
      qualification(form).then(res => {
        console.log(res, 55)
        this.submintLoading = false;
        if (res.code == 0) {
          this.$toast.fail(res.msg);
          return;
        }
        if (res.code == 1) {
          this.$cache.sessionSet('i', this.formData.identity)
          this.$cache.sessionSet('n', this.formData.name)
          this.$router.push(`/result?channel_id=${this.formData.channel_key}&no=${this.formData.check_no}`);
        }
      }).catch(err => {
        this.submintLoading = false;
        this.$toast.fail('错误，请联系管理员！');
      })
    },
    openSeleteAddress() {
      this.isShowAddress = true;
    },
    confirmAddress(e) {
      this.formData.province = e[0].name
      this.formData.district = e[1].name
      this.formData.city = e[2].name
      this.location = e[0].name + '/' + e[1].name + '/' + e[2].name
      this.isShowAddress = false;
    },
    // 验证表单
    validateForm() {
      // 基本验证逻辑
      if (!this.formData.name) {
        this.$toast("请输入真实姓名");
        return false;
      }
      if (!this.formData.identity) {
        this.$toast("请输入身份证号码");
        return false;
      }
      // if (!this.formData.age || this.formData.age < 18) {
      //   this.$toast("请输入有效年龄");
      //   return false;
      // }

      // if (!this.formData.gender) {
      //   this.$toast("请选择性别");
      //   return false;
      // }
      if (!this.formData.province) {
        this.$toast("请选择地址");
        return false;
      }
      if (!this.zcForm.sesame_score) {
        this.$toast("请选择芝麻分");
        return false;
      }
      if (!this.zcForm.huabei_quota) {
        this.$toast("请选择花呗额度");
        return false;
      }
      if (!this.zcForm.baitiao_quota) {
        this.$toast("请选择白条额度");
        return false;
      }
      if (!this.zcForm.credit_status) {
        this.$toast("请选择信用状况");
        return false;
      }
      if (!this.zcForm.work) {
        this.$toast("请选择职业");
        return false;
      }
      return true;
    },

    // 切换资产选择
    toggleAsset(asset) {
      const index = this.assets.indexOf(asset);
      if (index > -1) {
        // 如果已选中，则取消选择
        this.assets.splice(index, 1);
      } else {
        // 如果未选中，则添加选择
        // 如果选择"以上都没有"，则清空其他选择
        if (asset === "no") {
          this.assets = ['no'];
        } else {
          // 如果选择其他选项，则移除"以上都没有"
          this.assets = this.assets.filter(
            (item) => item !== "no"
          );
          this.assets.push(asset);
        }
      }
    },
    parseIdCard(idCard) {
      if (!/^\d{17}[\dXx]$/.test(idCard)) {
        this.identityError = true;
        return { error: "身份证号格式不正确" };
      }
      this.identityError = false;
      const birth = idCard.substring(6, 14);
      const year = parseInt(birth.substring(0, 4), 10);
      const month = parseInt(birth.substring(4, 6), 10);
      const day = parseInt(birth.substring(6, 8), 10);
      const birthday = new Date(year, month - 1, day);
      const now = new Date();
      let age = now.getFullYear() - year;
      if (
        now.getMonth() + 1 < month ||
        (now.getMonth() + 1 === month && now.getDate() < day)
      ) {
        age--;
      }
      const genderCode = parseInt(idCard.substring(16, 17), 10);
      const gender = genderCode % 2 === 1 ? "1" : "2";
      return { birthday, age, gender };
    }
  },
};
</script>

<style lang="less" scoped>
.mt-10 {
  margin-top: 10px;
}

.tip-box {
  height: 330px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .info-tip-popup {
    width: 320px;
    border-radius: 16px;
    border: 4px solid #DCF2FF;
    background: linear-gradient(115deg, #B9DDF2 1.9%, #E9F6FF 97.58%);
    padding: 0 16px;
    position: relative;

    .bg {
      position: absolute;
      right: -6px;
      top: -56px;
      width: 151px;
      height: 151px;

      img {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
      }
    }

    .title {
      color: #254774;
      font-family: "Alimama ShuHeiTi";
      font-size: 30px;
      font-style: normal;
      font-weight: 700;
      margin-top: 10px;
      margin-bottom: 16px;
    }

    .info-tip-box {
      border-radius: 16px;
      border: 4px solid #DCF2FF;
      background: linear-gradient(115deg, #EBFFFD 1.9%, #E9F6FF 97.58%);
      padding: 10px 0px;
      padding-top: 14px;

      .two-title {
        color: #FF7B1B;
        text-align: center;
        font-size: 20px;
        font-weight: 700;
        padding-bottom: 14px;
      }

      .msg {
        color: rgba(37, 71, 116, 0.80);
        text-align: center;
        font-size: 13px;
        font-weight: 500;
        padding-bottom: 18px;
      }
    }

    .btn-group {
      display: flex;
      justify-content: space-between;
      margin: 14px 0;

      .btn {
        width: 130.22px;
        height: 46px;
        border-radius: 25px;
        border: 1px solid #CDEDFF;
        background: linear-gradient(90deg, #4D9BFF 0%, #67D1FF 100%);
        box-shadow: 0 4px 4px 0 rgba(3, 92, 242, 0.12);
        color: #FFF;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 21px;
      }
    }
  }
}

.loan-application-page {
  position: relative;
  padding: 0 16px;
  background: linear-gradient(180deg, #b9ddf2 -1.32%, #f3fbff 75.05%);
  min-height: 100vh;

  .header-conatiner {
    text-align: left;
    padding: 0 0 0 12px;

    .title-1 {
      background: linear-gradient(91deg, #16375a 0%, #2b4b72 50%, #5f82a8 100%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
      font-family: "阿里妈妈数黑体 Bold";
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 33px;
    }

    .title-2 {
      color: #ff7b00;
      font-family: "阿里妈妈数黑体 Bold";
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 33px;
    }

    .subtitle {
      margin-top: 10px;
      color: #4c739c;
      font-family: "Source Han Sans CN";
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
    }

    .img-box {
      position: relative;
      margin-top: -10px;
      width: 120px;
      height: 120px;

      .img-1 {
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
      }
    }

    .title-1.channel {
      margin-bottom: 20px;
    }

    .img-box.channel {
      position: absolute;
      right: 20px;
      top: 0;
    }
  }

  .disclaimer {
    width: 343.334px;
    height: 32px;
    background: linear-gradient(91deg, #e8f7ff 0%, #cdecff 100%);
    border-radius: 16px 16px 16px 16px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    p {
      padding-left: 12px;
      color: #2e517b;
      text-align: center;
      font-family: "Source Han Sans CN";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
    }
  }
}

.confirmation-page {
  position: relative;
  min-height: 100vh;
  background: linear-gradient(180deg, #b9ddf2 -1.32%, #f3fbff 75.05%);
  padding: 0 16px;

  // 顶部额度展示区域
  .header-section {
    position: relative;

    .amount-display {
      z-index: 2;

      .amount-title-tip {
        font-family: "Source_Han_Sans_CN", sans-serif;
        font-size: 14px;
        color: #254774;
        margin-bottom: 8px;
      }

      .amount-value {
        gap: 4px;

        .currency {
          font-family: "Source_Han_Sans_CN", sans-serif;
          font-weight: bold;
          font-size: 24px;
          color: #254774;
        }

        .amount {
          font-family: "Source_Han_Sans_CN", sans-serif;
          font-weight: bold;
          font-size: 40px;
          color: #254774;
        }
      }
    }

    .img-box {
      position: absolute;
      right: 0px;
      top: -20px;

      img {
        width: 120px;
        height: 120px;
        background-size: 100% 100%;
      }
    }
  }

  // 产品特性说明
  .features-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    padding: 0 12px;

    .feature-item {
      display: flex;
      align-items: center;
      gap: 2px;

      svg {
        width: 10px;
        height: 10px;
      }

      span {
        font-family: "Source_Han_Sans_CN", sans-serif;
        font-size: 10px;
        color: #2e517b;
        white-space: nowrap;
      }
    }
  }

  // 提示信息
  .tip-section {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
    padding: 0 16px;

    img {
      width: 22px;
      height: 22px;
    }

    span {
      font-family: "Source_Han_Sans_CN", sans-serif;
      font-weight: 500;
      font-size: 13px;
      color: #ff7b1b;
    }
  }

  // 进度条
  .progress-section {
    background: rgba(255, 255, 255, 0.8);
    border: 4px solid #b9ddf2;
    border-radius: 16px;
    padding: 16px 0;

    .progress-container {
      display: flex;
      align-items: center;
      justify-content: center;

      .progress-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;

        .progress-icon {
          display: flex;
          width: 36px;
          height: 36px;

          &.phone {
            width: 13px;
            height: 20px;
          }

          &.walltet {
            width: 22px;
            height: 22px;
            flex-shrink: 0;
            aspect-ratio: 1/1;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }

        &.completed .progress-text {
          color: rgba(0, 0, 0, 0.8);
        }
      }

      .progress-line {
        width: 50px;
        height: 2px;
        background: #d9d9d9;
        margin: 0 10px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url("/images/icon-Line178.png");

        &.completed {
          background-image: url("/images/icon-Line177.png");
        }
      }
    }

    .title-box {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-evenly;
      margin-top: 8px;

      .progress-text {
        color: #bdbdbd;
        text-align: center;
        font-family: "Source Han Sans CN";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;

        &.active {
          color: #f90;
          font-weight: 700;
          font-size: 15px;
        }
      }
    }
  }

  // 提示信息2、3和5
  .tip-section-2,
  .tip-section-3,
  .tip-section-5 {
    margin-top: 6px;
    height: 32px;
    background: linear-gradient(91deg, #e8f7ff 0%, #cdecff 100%);
    border-radius: 16px 16px 16px 16px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    padding-left: 16px;

    img {
      width: 16px;
      height: 16px;
    }

    span {
      height: 21px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 14px;
      color: #2e517b;
      line-height: 21px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      color: #2e517b;
    }
  }

  .tip-section-3 {
    span {
      color: #ff7b1b;
      text-align: center;
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
    }
  }

  // 表单区域
  .form-section {
    border-radius: 16px;
    border: 4px solid #b9ddf2;
    background: #b9ddf2;
    box-shadow: 0 4px 13.5px 2px rgba(0, 0, 0, 0.02);

    .form-card {
      .form-header {
        display: flex;
        align-items: center;
        padding: 10px;
        gap: 4px;

        i {
          background-image: url("/images/icon-start.png");
          width: 16px;
          height: 16px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }

        span {
          font-family: "Source_Han_Sans_CN", sans-serif;
          font-weight: 500;
          font-size: 14px;
          color: #2e517b;
        }
      }

      .form-content {
        padding: 0 12px;
        border-radius: 16px;
        background: #fafdff;
        box-shadow: 0 4px 13.5px 2px rgba(0, 0, 0, 0.02);

        .form-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 0;
          border-bottom: 1px solid #eff6ff;

          label {
            color: rgba(0, 0, 0, 0.6);
            font-family: "Source Han Sans CN";
            font-size: 15px;
            font-style: normal;
            font-weight: 350;
            line-height: 21px;
          }

          .input-box {
            flex: 1;
            min-width: 200px;
            text-align: end;
            color: rgba(0, 0, 0, 0.7);
            font-family: "Source Han Sans CN";
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            line-height: 21px;
            position: relative;

            input {
              width: calc(100% - 10px);
              border: none;
              background: none;
              font-family: "Source_Han_Sans_CN", sans-serif;
              font-weight: 500;
              font-size: 15px;
              color: rgba(0, 0, 0, 0.7);
              text-align: right;
              outline: none;

              &::placeholder {
                color: rgba(0, 0, 0, 0.7);
              }
            }
          }

          // 性别选择器
          .gender-selector {
            display: flex;
            gap: 8px;

            .gender-btn {
              width: 60px;
              height: 32px;
              border: 1px solid #d9d9d9;
              border-radius: 16px;
              background: #fff;
              font-family: "Source_Han_Sans_CN", sans-serif;
              font-weight: 500;
              font-size: 15px;
              color: #959595;
              cursor: pointer;
              transition: all 0.3s ease;

              &.active {
                background: #254774;
                border-color: #254774;
                color: #fff;
              }
            }
          }

          // 位置选择器
          .location-selector {
            display: flex;
            align-items: center;
            gap: 8px;
            min-width: 200px;
            justify-content: flex-end;

            span {
              font-family: "Source_Han_Sans_CN", sans-serif;
              font-weight: 500;
              font-size: 15px;
              color: #3c3c3c;
            }
          }

          // 芝麻分选择器
          .selector {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            margin-top: 10px;

            .score-btn {
              width: 98.2px;
              height: 32px;
              border: 1px solid #d9d9d9;
              border-radius: 16px;
              background: #fff;
              font-family: "Source_Han_Sans_CN", sans-serif;
              font-weight: 500;
              font-size: 15px;
              color: #959595;
              text-align: center;
              cursor: pointer;
              transition: all 0.3s ease;
              white-space: nowrap;

              &.active {
                background: #254774;
                border-color: #254774;
                color: #fff;
              }
            }
          }

          // 职业选择器
          .occupation-selector {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            max-width: 280px;

            .occupation-btn {
              height: 32px;
              padding: 0 12px;
              border: 1px solid #d9d9d9;
              border-radius: 16px;
              background: #fff;
              font-family: "Source_Han_Sans_CN", sans-serif;
              font-weight: 500;
              font-size: 15px;
              color: #959595;
              cursor: pointer;
              transition: all 0.3s ease;
              white-space: nowrap;

              &.active {
                background: #254774;
                border-color: #254774;
                color: #fff;
              }
            }
          }

          // 资产选择器
          .asset-selector {
            display: flex;
            flex-wrap: wrap;
            gap: 10px 8px;

            .asset-btn {
              width: 98.2px;
              height: 32px;
              border: 1px solid #d9d9d9;
              border-radius: 16px;
              background: #fff;
              font-family: "Source_Han_Sans_CN", sans-serif;
              font-weight: 500;
              font-size: 15px;
              color: #959595;
              cursor: pointer;
              transition: all 0.3s ease;
              white-space: nowrap;

              &.active {
                background: #254774;
                border-color: #254774;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }

  .asset-tip {
    height: 44px;
    line-height: 44px;
    background: linear-gradient(91deg, #cdecff 0%, #e8f7ff 100%);
    border-radius: 51px 51px 51px 51px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #2e517b;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }

  // 提交按钮
  .submit-button-container {
    padding: 0 16px 20px;

    .submit-button {
      width: 100%;
      height: 50px;
      background: linear-gradient(to right, #4d9bff, #67d1ff);
      border: 1px solid #cdedff;
      border-radius: 25px;
      box-shadow: 0px 4px 4px 0px rgba(3, 92, 242, 0.12);
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0px 6px 8px 0px rgba(3, 92, 242, 0.2);
      }

      &:active {
        transform: translateY(0);
      }

      span {
        font-family: "Source_Han_Sans_CN", sans-serif;
        font-weight: bold;
        font-size: 16px;
        color: white;
        line-height: 21px;
      }
    }
  }
}

.err-tip {
  position: absolute;
  text-align: end;
  bottom: -18px;
  right: 0;
  font-size: 12px;
  color: red;
}
</style>
